export default __webpack_public_path__ + "static/media/chicken-with-mash.8da1b32f.png";